export const GET_EDITOR_DETAILS = "GET_EDITOR_DETAILS"
export const GET_EDITOR_DETAILS_SUCCESS = "GET_EDITOR_DETAILS_SUCCESS"
export const GET_EDITOR_DETAILS_FAIL = "GET_EDITOR_DETAILS_FAIL"
export const CLEAR_CONTENT_EDITOR_DETAILS = "CLEAR_CONTENT_EDITOR_DETAILS"
export const UPDATE_CONTENT_EDITOR_DETAILS_STATE = "UPDATE_CONTENT_EDITOR_DETAILS_STATE"